<template>
    <div class="layout-topbar">
        <div class="layout-topbar-wrapper">
            <div class="layout-topbar-left">
                <router-link to="/">
                    <div class="layout-topbar-logo" id="logolink" style="cursor: pointer; outline: none">
                        <img 
                            v-if="authStore.selectedProduct !== null" 
                            id="app-logo" 
                            alt="product logo" 
                            :src="authStore.companyLogoUrl" 
                            :class="['', { 'footer-logo': !authStore.isGodUser && !authStore.isFallbackProductLogo }]"
                            />
                    </div>
                </router-link>
            </div>

            <div class="layout-topbar-right">
                <a class="menu-button" href="#" @click="$emit('menu-button-click', $event)">
                    <i class="pi pi-bars"></i>
                </a>

                <ul class="layout-topbar-actions">
                    <li class="topbar-item user-profile" :class="{ 'active-topmenuitem': props.activeTopbarItem === 'profile' }">
                        <a href="#" @click="onTopbarItemClick($event, 'profile')">
                            <Badge class="profile-image text-white mr-2" size="large">
                                <span> <i class="pi pi-user" /></span>
                            </Badge>
                            <div class="profile-info mt-2">
                                <h6>{{ authStore.getLoggedUserName }}</h6>
                            </div>
                        </a>

                        <ul class="fadeInDown">
                            <li class="layout-submenu-header">
                                <!-- <img class="profile-image" src="layout/images/avatar-profile.png" alt="demo" /> -->
                                <div class="profile-info">
                                    <h6>{{ authStore.getLoggedUserName }}</h6>
                                    <!-- <span>Software Engineer</span> -->
                                </div>
                            </li>
                            <!--
                            <li role="menuitem">
                                <a href="#" @click="onTopbarSubItemClick($event)">
                                    <i class="pi pi-cog"></i>
                                    <h6>Settings</h6>
                                </a>
                            </li>
                            -->
                            <li v-if="!ssoEntraEnabled" role="menuitem">
                                <a href="#" @click="resetPassword">
                                    <i class="pi pi-key"></i>
                                    <div class="settings-item">
                                        <h6>Reset Password</h6>
                                    </div>
                                </a>
                            </li>
                            <li role="menuitem">
                                <Logout />
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import Logout from '@/modules/auth/components/Logout.vue';

import { defineEmits, defineProps, ref, computed, watch } from 'vue';
import { useAuthStore } from '@/modules/auth/store';
import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';
import { userCompanyPreference } from '@/composables/CompanyPreferenceComposable';

const emit = defineEmits(['menu-button-click', 'topbar-item-click']);
const props = defineProps({
    // topbarTheme: {
    //     type: String,
    // },
    activeTopbarItem: {
        type: String,
    },
});
const authStore = useAuthStore();
const { fetchCompanyPreference } = userCompanyPreference();

const ssoEntraEnabled = ref(false);

const companyId = computed(() => authStore.getLoggedUserCompanyId);

function loadCompanyPreference() {
    if (companyId.value && companyId.value > 0) {
        fetchCompanyPreference(companyId.value).then((prefs) => {
            ssoEntraEnabled.value = prefs?.sso_entra_enabled === 1;
        });
    }
}

watch(companyId, loadCompanyPreference);
loadCompanyPreference();

function onTopbarItemClick(event, item) {
    emit('topbar-item-click', { originalEvent: event, item: item });
    event.preventDefault();
}
/*
function onTopbarSubItemClick(event) {
    event.preventDefault();
}
*/

async function resetPassword() {
  try {
    const data = await authApi.get('v2/admin/users/password-reset-without-email');

    if (data.statusCode === 200) {
      await authStore.logout();
      window.location.href = data.data.reset_url;
    } else {
      showToast({ severity: 'error', summary: 'Error' }, 'Failed to generate password reset link');
    }
  } catch (error) {
    showToast({ severity: 'error', summary: 'Error' }, error.response?.data?.message || 'Failed to reset password');
  }
}


</script>

<style scoped>
.footer-logo {
  width: 130px !important;
  height: 55px !important;
  object-fit: contain;
  display: block;
}
</style>
